import React from 'react';
import { StarIcon, UsersIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="py-8 px-4 bg-white/50 border-y border-brand-green/10" data-id="element-159">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12" data-id="element-160">
        <div className="flex items-center gap-2" data-id="element-161">
          <div className="flex text-brand-gold" data-id="element-162">
            {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 fill-current" data-id="element-163" />)}
          </div>
          <span className="font-medium text-gray-700" data-id="element-164">
            4.9/5 de calificación
          </span>
        </div>

        <div className="hidden md:block w-px h-8 bg-brand-green/20" data-id="element-165"></div>

        <div className="flex items-center gap-3" data-id="element-166">
          <div className="bg-brand-green/10 p-2 rounded-full" data-id="element-167">
            <UsersIcon className="w-5 h-5 text-brand-green" data-id="element-168" />
          </div>
          <span className="font-medium text-gray-700" data-id="element-169">
            <strong className="text-brand-green" data-id="element-170">+2,500 mujeres</strong> ya
            tienen esta guía
          </span>
        </div>
      </div>
    </section>;
}